module.exports = __webpack_public_path__ + "static/media/Vacant_property.4d793c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Vacant_property.png
// module id = 3041
// module chunks = 0